import React from "react";
import { BrowserRouter, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { isLogin } from "src/app-redux/auth/authSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { RouteGuard } from "src/modules/auth/components/RouteGuard";
import { ROUTES } from "./routes";

function AppRoutes() {
  const user = useAppSelector(isLogin);
  const location = useLocation();
  const isAuthRoute = location.pathname.startsWith("/auth");
  const isRoot = location.pathname === "/";

  return (
    <Switch>
      {ROUTES.map((route, i) => (
        <Route key={i} path={route.path}>
          {route.guard ? (
            <RouteGuard path={route.path} redirectPath="/auth">
              {<route.component />}
            </RouteGuard>
          ) : (
            <route.component />
          )}
        </Route>
      ))}
      {!isAuthRoute && !user && <Redirect to={{ pathname: "/auth/login" }} />}
      {isRoot && user && <Redirect to={{ pathname: "/work-order" }} />}
    </Switch>
  );
}

export function AppRouting() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
